module.exports = __webpack_public_path__ + "img/upgrade-colse.d6e4ec89.svg";